import {useContext, useMemo} from 'react';
import {LotsContext} from "../../auction-lots-listing";

const useIsLotSelected = (auction_id) => {
    const {changeLots} = useContext(LotsContext);
    
    // Создаем Set из ID для O(1) поиска вместо O(n)
    const selectedLotsSet = useMemo(() => {
        if (!changeLots || changeLots.length === 0) {
            return new Set();
        }
        return new Set(changeLots.map(lot => lot.auction_id));
    }, [changeLots]);
    
    return useMemo(() => {
        return selectedLotsSet.has(auction_id);
    }, [selectedLotsSet, auction_id]);
};

export default useIsLotSelected;
